import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import CloseImg from '../../images/close-24px.svg';
import '../../css/Cards/ImageModal.css';
const bodyEl = document.getElementsByTagName('body')[0];

/**
 * Display image in a modal
 * @param {any} props
 */
const ImageModal = ({src, onClose}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const hide = () => {
    setTimeout(onClose, 350);
    setMounted(false);
  };
  const escListener = (event) => {
    if (event.key === 'Escape') {
      const isNotCombinedKey = !(
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey
      );
      if (isNotCombinedKey) {
        hide();
      }
    }
  };
  useEffect(() => {
    document.addEventListener('keydown', escListener);
    return () => document.removeEventListener('keydown', escListener);
  });
  useEffect(() => {
    bodyEl.className = ' noScroll';
    return () => (bodyEl.className = '');
  });

  return (
    <div className={'modal modal' + (mounted ? '--displayed' : '--hided')}>
      <div className="modal__container">
        <div className="modal__actions">
          <button
            className="modal__closeAction"
            onClick={(evt) => {
              evt.preventDefault();
              hide();
            }}
          >
            <img src={CloseImg} alt="Close" className="modal__closeIcon" />
            <span className="modal__closeHelp">Close</span>
          </button>
        </div>
        <div
          className="modal__figure"
          onClick={(evt) => {
            evt.preventDefault();
            if (evt.target && evt.target.className === 'modal__image') return;
            hide();
          }}
        >
          <img src={src} className="modal__image" />
        </div>
      </div>
    </div>
  );
};

ImageModal.displayName = 'ImageModal';
ImageModal.propTypes = {
  src: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default ImageModal;



// WEBPACK FOOTER //
// ./src/components/Cards/ImageModal.js